
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ImportResult_$reflection } from "../../Shared/Importer.js";
import { union_type, string_type, class_type, record_type, option_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection } from "../../Shared/Shared.js";

export class State extends Record {
    constructor(Import, FormState) {
        super();
        this.Import = Import;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Importer.ConstructionSite.Types.State", [], State, () => [["Import", option_type(ImportResult_$reflection())], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ImportData", "DataImported", "Validate", "ValidationCompleted", "DownloadTemplate", "DownloadedTemplate", "BlobReceived", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Importer.ConstructionSite.Types.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(ImportResult_$reflection())]], [["Item", class_type("Browser.Types.FormData", undefined)]], [["Item", ClientApiResponse$1_$reflection(ImportResult_$reflection())]], [], [["Item1", class_type("Fetch.Types.Response")], ["Item2", string_type]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", class_type("System.Exception")]]]);
}

